import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button, Spinner } from 'react-bootstrap';

const EstadoCuentaHeader = ({ rfcSeleccionado, cargando, handleSeleccionarArchivo, cuentaSeleccionada }) => {
    return (
        <Row className="align-items-center">
            <Col>
                <h5 className="mb-0 text-dark fw-bold">
                    <i className="fas fa-file-invoice-dollar me-2 text-primary"></i>
                    Estado de Cuenta Bancario
                </h5>
            </Col>
            <Col xs="auto">
                <Button
                    variant="primary"
                    size="sm"
                    onClick={() => document.getElementById('fileInput').click()}
                    disabled={!rfcSeleccionado || !cuentaSeleccionada || cargando}
                >
                    {cargando ? (
                        <>
                            <Spinner animation="border" size="sm" className="me-1" />
                            Importando...
                        </>
                    ) : (
                        <>
                            <i className="fas fa-upload me-1"></i>
                            Importar
                        </>
                    )}
                </Button>
                <input
                    id="fileInput"
                    type="file"
                    accept=".csv"
                    style={{ display: 'none' }}
                    onChange={handleSeleccionarArchivo}
                />
            </Col>
        </Row>
    );
};



EstadoCuentaHeader.propTypes = {
    rfcSeleccionado: PropTypes.string,
    cargando: PropTypes.bool,
    handleSeleccionarArchivo: PropTypes.func,
    cuentaSeleccionada: PropTypes.string
};

export default EstadoCuentaHeader;
